import gql from "graphql-tag";
export const getAllSites = `query ($where: JSON){
        allSites(where: $where){
          Sites {
            id
            name
            siteid
          }
        }
      }
`;
export const getUserData = `query ($where: JSON, $last: Int, $first: Int,$sitewhere:JSON) {
  allUserdata(where: $where, last: $last, first: $first) {
    totalCount
    Userdata {
      id
      role
      email
      phonenumber
      firstname
      lastname
      username
      mappedUser(where: $sitewhere){
        Usersitemaps{
          siteid
          mappedsiterel{
            Sites{
              name
            }
          }
        }
      }
    }
  }
}
  `;
export const saveUserdata = gql`
  mutation saveUserdata($obj: UserdataInput!) {
    saveUserdata(obj: $obj) {
      id
    }
  }
`;
export const saveUserSite = gql`
  mutation saveUsersitemap($obj: UsersitemapInput!) {
    saveUsersitemap(obj: $obj) {
      id
      siteid
      userid
      mappeduserrel {
        Userdata {
          id
        }
      }
    }
  }
`;
export const getUserDataById = (id) => `{
  allUserdata (where:{active:"1",id:${id}}){
    Userdata {
      id
      role
      email
      phonenumber
      firstname
      lastname
      username
      istrained
      mappedUser(where:{active:1}){
        Usersitemaps{
          siteid
          id
          active
          mappedsiterel{
            Sites{
              name
              id
            }
          }
        }
    }
  }
}
}`;
export const allUserSiteMap = `query allUsersitemaps($where:JSON) {
  allUsersitemaps (where:$where){
    Usersitemaps{
      active
      id
      userid
      userId
      siteid
    }
  }
}`;
